import { Injectable } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { Observable } from "rxjs";
import { InputDialogOptions } from "./input-dialog";
import { InputDialogComponent } from "./input-dialog.component";


@Injectable()
export class InputDialogService {

    constructor(private matDialog: MatDialog) {}

    // #region Close All Dialogs Service Call

    CloseAllDialogs(): void {
        this.matDialog.closeAll();
    }

    // #endregion

    // #region Input Dialog Service Call 

    Open(options?: InputDialogOptions): Observable<string> {
        const openHandle = this.matDialog.open(InputDialogComponent, {
            disableClose: true,
            data: {
                TitleText: 'Information Requested',
                MessageText: '',
                InputLabel: '',
                InputText: '',
                OKText: 'OK',
                CancelText: 'Cancel',
                AllowBlankResponse: false,
                ...options,
            },
            maxHeight: '85vh',
            // width: '500px',
            // height: (options && options.height) || '13rem'
        });

        return openHandle.afterClosed();
    }

    // #endregion
}